import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500 text-secondary-950 text-base">
                <i className="ri-movie-2-line"></i>
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">
                我的老婆姐姐
              </span>
            </div>
            <p className="text-sm text-secondary-200 leading-relaxed max-w-md">
              专注影视剧资讯、剧情介绍与演员信息的内容平台，帮助每一位影迷快速了解最新影视动态，
              找到下一部值得追的好剧。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-3 text-sm">
              快速导航
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/category/tv" className="text-secondary-200 hover:text-accent-400 transition-colors">
                  电视剧
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-secondary-200 hover:text-accent-400 transition-colors">
                  电影
                </Link>
              </li>
              <li>
                <Link to="/actors" className="text-secondary-200 hover:text-accent-400 transition-colors">
                  演员库
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-secondary-200 hover:text-accent-400 transition-colors">
                  搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-3 text-sm">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2 text-secondary-200">
                <i className="ri-mail-line"></i>
                <span>contact@wlpjj-demo.com</span>
              </li>
              <li className="flex items-center gap-2 text-secondary-200">
                <i className="ri-weibo-line"></i>
                <span>@我的老婆姐姐</span>
              </li>
              <li>
                <Link to="/about" className="text-secondary-200 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-300">
          <p>© 2024 我的老婆姐姐 · 本站所有影视与演员资料均为演示用虚拟内容</p>
          <p>内容仅供参考，不构成任何观看建议</p>
        </div>
      </div>
    </footer>
  );
}